export const promptFormErrorMessages = {
  UNAUTHORIZED: 'Authorization failed. Please double check your OpenAI API key',
  BAD_REQUEST:
    'Your request is too long and requires more than 2049 tokens. Please reduce your prompt, or break it into two thoughts!'
};
